import Vue from 'vue'
import Vuex from "vuex";

Vue.use(Vuex);
Vue.config.productionTip = false

const state = {
    currentUser: {
        id: null,
        authorities: [],
    },
    env: {
        projectMediaUrl: null,
        spaceMediaUrl: null,
        userMediaUrl: null,
        googleMapsApiKey: null,
    }
};

const getters = {
    userHasRolePro: (state, getters) => {
        return getters.userHasRole('ROLE_PRO');
    },

    userHasRole: (state) => (roleName) => {
        return state.currentUser.authorities.filter(e => e.authority === roleName).length
    }
}

const store = new Vuex.Store({
    state: state,
    getters: getters,
});

store.replaceState(window.__INITIAL_STATE__); //set in vuex.html

export default store;


// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/store/index.js